export default "__VITE_ASSET__BSV3bQxi__"